import { BIEventPayload } from '@wix/da-shared-react/pkg/biLogger/types';
import { AppState } from '../types/store';
import { BiView, Pages } from '../../constants';
import { getPage, getCurrentOrder, getThisTopic, getThisGroup } from './page';
import { getIsCurrentStreamEmpty } from '../selectors/stream';
import {
  getFacetPageType,
  isSingleTopicPage,
  getActiveContentTypeFilter,
  getPageBiMetadata,
} from './facet';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import { getIsNetworkBarPage } from './app';

export function getBiView(state: AppState): string {
  if (getIsNetworkBarPage(state)) {
    // all the non-faceted pages should return 'browse' for view
    return 'browse';
  }

  return getPage(state) === Pages.Search ? BiView.Search : BiView.Browse;
}

export function getComponent(state: AppState): string | undefined {
  if (getIsNetworkBarPage(state)) {
    return `${state.currentPageData?.pageType ?? 'home'} ${state.currentPageData
      ?.feedType ?? ''}`.trim();
  }

  // bi wants this singular if it's an event on a single/unique topic page
  if (isSingleTopicPage(state)) {
    return 'topic';
  }

  const pageType = getFacetPageType(state);

  if (pageType === 'posts') {
    const contentType = getActiveContentTypeFilter(state) ?? 'posts';
    const convertedContentType =
      contentType === 'status-updates' ? 'statuses' : contentType;
    return convertedContentType;
  }

  return pageType;
}

export function getBiDetails(state: AppState): Partial<BIEventPayload> {
  if (!getIsNetworkBarPage(state)) {
    return {};
  }

  switch (state.currentPageData?.pageType) {
    case 'groups':
      return {
        typeid: ResourceType.GROUP,
        itemid: getThisGroup(state)?.userId,
        is_empty_state_view: getIsCurrentStreamEmpty(state) ? 1 : 0,
      };
    case 'topic':
      return {
        typeid: getThisTopic(state)?.typeId,
        itemid: getThisTopic(state)?.itemId,
      };
    case 'popular':
      return {
        sort_type: getCurrentOrder(state),
      };
    case 'home':
    case 'watch':
      return {
        is_empty_state_view: getIsCurrentStreamEmpty(state) ? 1 : 0,
      };
    default:
      return {};
  }
}

export function getPageViewData(state: AppState): BIEventPayload {
  return {
    view: getBiView(state),
    component: getComponent(state),
    metadata: getPageBiMetadata(state),
    ...getBiDetails(state),
  };
}
